import api from '../../services/service'

export default {
  data () {
    return {
      username: '',
      password: '',
      branch: '',
      date_time_start: new Date()
    }
  },
  methods: {
    sigin () {
      this.$store.commit('Loading')
      let body = {
        'username': this.username,
        'password': this.password
      }
      api.isLogin(this.CompanyConfig.base_api,
        body,
        result => {
          if (result.response === 'success') {
            sessionStorage.token = result.data.token
            this.$store.state.token = result.data.token
            sessionStorage.Url = this.CompanyConfig.base_api
            this.getProfile()
          } else {
            this.alert_msg('warning', 'เข้าสู่ระบบ', result.message)
            this.$store.commit('Loading')
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    getProfile () {
      api.userDetail(sessionStorage.Url,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        {},
        result => {
          if (result.response === 'success') {
            sessionStorage.user = JSON.stringify(result.data)
            this.$store.state.user = result.data
            this.getRoleMenu(this.$store.state.user.role_id)
            setTimeout(() => {
              this.$store.commit('Loading')
              if (this.$store.state.user.role_id === 4) {
                this.$router.push('/calendar')
              } else {
                this.$router.push('/')
              }
            }, 1000)
            this.alert_msg('success', 'เข้าสู่ระบบ', 'ยินดีตอนรับคุณ ' + this.username + ' เข้าสู่ระบบ')
          } else {
            this.alert_msg('warning', 'เข้าสู่ระบบ', result.message)
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
          this.$store.commit('Loading')
        }
      )
    },
    getRoleMenu (val) {
      api.GetMisMenuRole(sessionStorage.Url,
        {
          headers: {
            'Access-Token': sessionStorage.token
          }
        },
        {role_id: val},
        result => {
          if (result.response === 'success') {
            sessionStorage.menu_page = JSON.stringify(result.data)
          } else {
            this.alert_msg('warning', 'เข้าสู่ระบบ', result.message)
          }
        },
        error => {
          alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    // this.branch = this.CompanyConfig.branch[0]
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/login.js